// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q9345","col":"styles_col__1sqVd","actions":"styles_actions__2UTBR","conflict":"styles_conflict__1J8EC"};